module.exports = __webpack_public_path__ + "static/03-486a802641d4ad7fff4da87e28dfbc31.jpg";